import React, { useState, useEffect, useRef } from "react";
import Helper from "../../common/helper";
import Global from "../../common/global";
import Header from "../../common/header";
import StickyFooter from "../UI/sticky-footer";
import { useSearchParams } from "react-router";
import ApiService from "../../services/api.service";
import LoadingScreen from "../../components/UI/loading-screen";
import ErrorComponent from "../UI/error";
import TagManager from "react-gtm-module";

import ProductStep from "../Steps/primary-product-step"; //[Primary] Product
import ReviewStep from "../Steps/review-step";
import PaymentStep from "../Steps/payment-step";
import ConfirmationStep from "../Steps/confirmation-step";
import SecondaryProductStep from "../Steps/secondary-product-step";
import SecondaryPersonalDetailStep from "../Steps/secondary-personal-detail-step";
import SecondaryAddressStep from "../Steps/secondary-address-step";
import ExploreStep from "../Steps/explore-step";
import CTA from "../../components/UI/cta"; //[Secondary] Address
import { phone } from "phone";

import {
  State,
  Country,
  Postcode,
  City,
  Home,
  Phone,
  Title,
  Mail,
  User,
} from "../../common/icons";
import { commissionJunctionRules } from "../../common/commission-junction-rules";

TagManager.initialize({
  gtmId: Global.GTM_ID,
});

const TERMS_CONDITIONS_LINK =
  "https://www.accorplus.com/en-au/about/terms-and-conditions";
const SSO_LOGIN = Global.LOGIN_URL;

function ExpressCheckout({ baseUrl, isLogged }) {
  const queryParams = new URLSearchParams(window.location.search);
  const [searchParams, setSearchParams] = useSearchParams();
  const [progress, setProgress] = useState(0);
  const [businessCategories, setBusinessCategories] = useState({});

  var renewalHash = searchParams.get("hash");
  const date = new Date();
  let currentDay = String(date.getDate()).padStart(2, "0");
  let currentMonth = String(date.getMonth() + 1).padStart(2, "0");
  let currentYear = date.getFullYear();
  let currentDate = `${currentYear}-${currentMonth}-${currentDay}`;
  var renewalDate = searchParams.get("date");
  //var renewalPmid = searchParams.get("pmid");

  // const [progress, setProgress] = useState(); // Progressbar State
  const [step, setStep] = useState(1); // Wizard Step state
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState({});
  const [languages, setLanguages] = useState([]); // get country id - API
  const [headerText, setHeaderText] = useState("");
  const [isProcessing, setIsProcessing] = useState(false); // Button Footer Sticky state
  const [userDataLoading, setUserDataLoading] = useState(true);
  const [isSecondaryMember, setIsSecondaryMember] = useState(true);

  // [Step] - Secondary Products
  const [secondaryProducts, setSecondaryMemberProducts] = useState([]);

  // const [checkboxAddress, setCheckboxAddress] = useState(false);
  // const [personalInput, setPersonalInput] = useState({});
  // const [addressInput, setAddressInput] = useState({});
  // const [billingAddress, setBillingAddress] = useState({});

  const [renewalData, setRenewalData] = useState({});
  const [opportunities, setOpportunities] = useState({});
  const [secondaryopportunities, setSecondaryOpportunities] = useState({});

  // [Step] - Products
  const [products, setProducts] = useState([]); //product step
  const [productError, setProductError] = useState(null);
  const [isProductLoaded, setIsProductLoaded] = useState(false); // isLoading

  const [isLoaded, setIsLoaded] = useState(false); // isLoading
  const [locationDatas, setLocationData] = useState([]); // get location Data - API
  const [locationDataCurrency, setLocationDataCurrency] = useState();

  const [subsidiary, setSubsidiary] = useState();

  const inputSecondaryPersonalEl = useRef([]);

  // [Step] - Review Order - CheckboxTerms
  const [checkBoxTerms, setCheckBoxTerms] = useState(false);

  const [memberCreationError, setMemberCreationError] = useState("");

  function handleCheckBoxTerms() {
    setCheckBoxTerms(!checkBoxTerms);
  }

  const countryList = Global.BILLING_COUNTRY_LIST.map((item) => {
    return { value: item, text: item };
  });

  // const [secondaryBillingAddressInput, setSecondaryBillingAddressInput] = useState({});
  const [secondaryCheckboxAddress, setSecondaryCheckboxAddress] =
    useState(true);
  const [secondaryFindMyaddessInGoogle, setSecondaryFindMyaddessInGoogle] =
    useState(false);
  const [secondaryGoogleAddressEmpty, setSecondaryGoogleAddressEmpty] =
    useState(false);

  const secondaryInputRef = useRef();
  const autoCompleteRef2 = useRef();
  const inputSecondaryAddressEl = useRef([]);
  const inputSecondaryAddressBillingEl = useRef([]);

  const [memberStatus, setMemberStatus] = useState(false);

  // [Footer][Step]
  const [reviewLoading, setReviewLoading] = useState(false); // Review confirm Loading Button

  // [Step][Primary] - Personal Details
  const [personalDetailsInput, setpersonalDetailsInput] = useState({});

  // Local Storage State
  const [localStorageDatas, setLocalStorageDatas] = useState({});

  // Member ID state - Confirm function
  const [memberId, setMemberId] = useState("");

  // // [Step][Secondary] - Personal Details
  // const [secondaryPersonalDetailsInput, setSecondaryPersonalDetailsInput] = useState({});

  // [Primary] Personal Details
  const personalDetailsInputFields = [
    {
      name: "email",
      type: "email",
      placeholder: "Email*",
      icon: Mail,
      required: true,
      value: "",
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "confirm_email",
      type: "email",
      placeholder: "Confirm Email*",
      icon: Mail,
      required: true,
      value: "",
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "title",
      type: "select",
      value: "Mr",
      placeholder: "Title",
      icon: Title,
      required: false,
      isError: false,
      message: "",
      valid: false,
      checking: false,
      options: Global.SALUTATION_LIST,
    },
    {
      name: "first_name",
      type: "text",
      maxLength: 25,
      placeholder: "First Name*",
      icon: User,
      required: true,
      value: "",
      message: "",
      isError: false,
      valid: false,
    },
    {
      name: "last_name",
      type: "text",
      placeholder: "Last Name*",
      maxLength: 25,
      icon: User,
      required: true,
      value: "",
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "phone_number",
      type: "tel",
      icon: Phone,
      required: true,
      value: "",
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "preferred_language",
      type: "select",
      options: Global.PREFERRED_LANGUAGE,
      placeholder: "",
      icon: User,
      required: false,
      value: "en",
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    // {
    //   name: 'tax_number',
    //   type: 'num',
    //   placeholder: 'Tax Number*',
    //   icon: Phone,
    //   required: true,
    //   value: '',
    //   message:'',
    //   isError: false,
    //   valid: false,
    //   checking: false
    // }
  ];

  // [Primary] Initialize Personal Details
  const [inputFields, setInputFields] = useState(personalDetailsInputFields);

  // [Secondary] Initialize Personal Details
  const [secondaryInputFields, setSecondaryInputFields] = useState(
    personalDetailsInputFields,
  );

  function setInputLanguages(setLanguage, input, translation) {
    let region = locationParam.country.toLowerCase() || "en_master";
    // if(region == 'ph' || region == 'in' || region == 'sg' || region == 'en') {
    if (region != "th" || region != "id" || region != "vn") {
      region = "en_master";
    }
    if (
      translation.length !== 0 &&
      allLanguages[region].selectYourMembership !== ""
    ) {
      let updatedPlaceholder = input.map((inputFields) => {
        if (inputFields.name) {
          return {
            ...inputFields,
            placeholder: translation[inputFields.textHolder],
          };
        } else {
          return {
            ...inputFields,
          };
        }
      });
      setLanguage(updatedPlaceholder);
    }
  }

  function getGtmProduct(product, index) {
    let products = [];
    if (product !== null) {
      var member = product;
      let item_selected = member[0]; // check
      // var getCoupon = Helper.checkCoupon(item_selected, couponData);
      var getCoupon = Helper.checkCoupon(item_selected, []);

      products.push({
        item_id: item_selected.item_group_id,
        item_name: item_selected.item_group_description,
        price:
          parseFloat(item_selected.purchase_price) +
          parseFloat(item_selected.tax_amt || item_selected.tax_amount),
        coupon: getCoupon.exists ? getCoupon.coupon_code_id : "No coupon",
        affiliation: "Affiliation name/Accor plus",
        currency: item_selected.currency_text,
        discount: getCoupon.exists ? getCoupon.total : 0.0,
        index: index,
        item_brand: "Accor Plus",
        item_category: item_selected.item_group_name,
        location_id: locationDatas.subsidiary,
        quantity: 1,
      });
    }
    return products;
  }

  function getPath(navigationStep) {
    var path =
      window.location.search +
      Helper.navigate(navigationStep) +
      commissionJunction;
    return path;
  }

  function productsForGtm() {
    let products = [];
    if (localStorageDatas.members[0].selected_product[0] !== undefined) {
      for (let i = 0; i < localStorageDatas.members.length; i++) {
        let item_selected = localStorageDatas.members[i].selected_product;
        // var getCoupon = Helper.checkCoupon(item_selected[0], couponData);
        var getCoupon = Helper.checkCoupon(item_selected[0], []);
        let member = localStorageDatas.members[i];
        products.push({
          item_id: member.selected_product[0].item_group_id,
          item_name: member.selected_product[0].item_group_description,
          price:
            parseFloat(member.selected_product[0].purchase_price) +
            parseFloat(
              member.selected_product[0].tax_amt ||
                member.selected_product[0].tax_amount,
            ),
          coupon: getCoupon.exists ? getCoupon.coupon_code_id : "No coupon",
          affiliation: "Accor Plus",
          currency: member.selected_product[0].currency_text,
          discount: getCoupon.exists ? getCoupon.total : 0.0,
          index: i,
          item_brand: "Accor Plus",
          item_category: member.selected_product[0].item_group_name,
          location_id: locationDatas.subsidiary,
          quantity: 1,
        });
      }
      return products;
    }
  }

  // Header modal
  const [showModal, setShowModal] = useState(false);

  const googleOptions = {
    fields: ["address_components", "geometry", "icon", "name"],
    types: ["address"],
  };

  //check if user is logged in
  const [isUserLogged, setIsUserLogged] = useState(true);
  const [userNsData, setUserNsData] = useState();

  const inputPromoEl = useRef([]);
  const locationParam = Helper.locationSelect();
  const readMeTerms = useRef(null);
  const [allLanguages, setAllLanguages] = useState([]); // get all Languages - API
  // #cj state tracker
  let commissionJunction = "";

  useEffect(() => {
    // setHeaderText('Select your membership');
    fetchLanguages();
    getStorageValue("renewal_data_obj");
    getUserData(renewalHash, currentDate);
    const locationParam = Helper.locationSelect();
    setIsUserLogged(true);

    runLocationData(locationParam);
  }, []);

  useEffect(() => {
    if (step <= 9) {
      getLocalStorageDatas();
    }
    setHeaderStepText();
    secondaryGoogleAPIAddress();
    // if(secondaryInputFields) {
    //   checkMemberExist({"email": secondaryInputFields[0].value})
    // }

    if (step === 6) {
      inputSecondaryPersonalEl.current["email"].focus();
    }

    if (step === 4) {
      personalRenewalData();
      setMemberStatus(true);
    }
  }, [step]);

  // Review terms and conditions button hover check
  function onMouseHover() {
    readMeTerms.current.classList.add("text-red");
  }

  function onMouseLeave() {
    readMeTerms.current.classList.remove("text-red");
  }

  function runLocationData(locationParam) {
    ApiService.getLocationData(locationParam)
      .then((res) => res.json())
      .then(
        (result) => {
          setLocationData(result);
          setIsLoaded(true);
          sessionStorage.setItem("location_data", JSON.stringify(result));
          setLocationDataCurrency(result.currency);
        },
        (error) => {
          setError(error);
        },
      );
  }

  // Header Text title
  function setHeaderStepText() {
    var currentStep = Helper.getSteps(step);
    const title = Helper.getStepsTitle(currentStep, languages);
    setHeaderText(title);
  }

  const fetchLanguages = async () => {
    const region = locationParam.country.toLowerCase() || "au";
    let regionLanguage;
    await ApiService.getLanguages()
      .then((res) => res.json())
      .then(
        (result) => {
          setAllLanguages(result);
          setLocalLanguage(result);
          var currentStep = Helper.getSteps(step);
          const title = Helper.getStepsTitle(currentStep, regionLanguage);
          setLanguages(regionLanguage);
          setHeaderText(title);
        },
        // No longer fetching and now loading from static file, no longer required
        // (error) => {
        //   setAllLanguages(languagesData);
        //   setLocalLanguage(languagesData);
        //   var currentStep = Helper.getSteps(step);
        //   const title = Helper.getStepsTitle(currentStep, regionLanguage);
        //   setLanguages(regionLanguage);
        //   setHeaderText(title);
        //   setInputLanguages(setInputFields, inputFields, languages);
        // }
      );

    function setLocalLanguage(data) {
      if (data) {
        var found = false;
        for (const [key, value] of Object.entries(data)) {
          if (key.indexOf(region) > -1) {
            if (window.location.href.indexOf("localhost") != -1) {
              found = true;
              regionLanguage = data["au"];
              if (key == "th") {
                found = true;
                regionLanguage = value;
              } else if (key == "vn") {
                found = true;
                regionLanguage = value;
              } else if (key == "id") {
                found = true;
                regionLanguage = value;
              } else {
                found = true;
                regionLanguage = data["en_master"];
              }
            } else {
              if (
                key == "th" &&
                window.location.pathname == "/th/th/registration/"
              ) {
                found = true;
                regionLanguage = value;
              } else if (
                key == "vn" &&
                window.location.pathname == "/vn/vi/registration/"
              ) {
                found = true;
                regionLanguage = value;
              } else if (
                key == "id" &&
                window.location.pathname == "/id/id/registration/"
              ) {
                found = true;
                regionLanguage = value;
              } else {
                found = true;
                regionLanguage = data["en_master"];
              }
            }
          }
        }
        if (!found) {
          regionLanguage = data["en_master"];
        }
      }
    }
  };

  const secondaryDetailsSubmit = (event) => {
    let suppOppResult = event;
    let input_data = {
      type_of_member: "supp",
      memberid: suppOppResult.memberid,
      leah_card_number: suppOppResult.leah_card_number,
    };

    sessionStorage.setItem(
      "secondary_selected_membership",
      JSON.stringify(input_data),
    );
    sessionStorage.setItem(
      "secondary_personal_details",
      JSON.stringify(input_data),
    );
    getLocalStorageDatas();
  };

  // [Primary] Personal Details Submit
  const secondaryPersonalDetailsSubmit = (event) => {
    // event.preventDefault()
    let secondaryArr = [];
    let storedData = secondaryInputFields.map((secondaryInputFields) => {
      if (secondaryInputFields.name) {
        return {
          name: secondaryInputFields.name,
          value: secondaryInputFields.value,
        };
      }
    });

    secondaryArr.push(storedData);
    var secondary_input_data = {};
    for (var i = 0; i < secondaryArr[0].length; i++) {
      secondary_input_data[secondaryArr[0][i].name] = secondaryArr[0][i].value;
    }

    sessionStorage.setItem(
      "secondary_personal_details",
      JSON.stringify(secondary_input_data),
    );
    goNextStep();
  };

  function removeProduct(product) {
    setStep(1);
    if (product.type_of_member === "supp") {
      window.sessionStorage.removeItem("secondary_selected_membership");
      window.sessionStorage.removeItem("secondary_personal_details");
      window.sessionStorage.removeItem("secondary_address_details");
    }
    let updatedProducts = secondaryProducts.map((item) => {
      if (item.item_group_id === product.selected_product[0].item_group_id) {
        return {
          ...item,
          isSelected: false,
        };
      } else {
        return {
          ...item,
        };
      }
    });
    setIsSecondaryMember(false);
    setSecondaryMemberProducts(updatedProducts);
  }

  // Edit Button Review Step
  function editReview(item) {
    if (item.type_of_member === "primary_owner") {
      setStep(1);
    } else if (item.type_of_member === "supp") {
      setStep(2);
    }
    setHeaderStepText();
  }

  // Membersip Localstorage store
  function storeMembershipData(identifier) {
    if (identifier === 1) {
      let selectedProduct = opportunities[0].item_groups.filter(
        (x) => x.isSelected === true,
      );
      var prevProd = JSON.parse(sessionStorage.getItem("selected_membership"));
      if (prevProd !== null) {
        if (selectedProduct[0]?.item_group_id !== prevProd[0]?.item_group_id) {
          // both aren't equal, remove the
          TagManager.dataLayer(
            Helper.gtmEcommerceCart(
              "remove_from_cart",
              "primary",
              getGtmProduct(prevProd, 0),
            ),
          );
          TagManager.dataLayer(
            Helper.gtmEcommerceCart(
              "add_to_cart",
              "primary",
              getGtmProduct(selectedProduct, 0),
            ),
          );
        }
      } else {
        TagManager.dataLayer(
          Helper.gtmEcommerceCart(
            "add_to_cart",
            "primary",
            getGtmProduct(selectedProduct, 0),
          ),
        );
      }
      sessionStorage.setItem(
        "selected_membership",
        JSON.stringify(selectedProduct),
      );

      /*if(secondaryopportunities.length > 0) {
        sessionStorage.setItem('secondary_selected_membership', JSON.stringify(secondaryopportunities[0].item_groups));
      }*/

      if (isSecondaryMember) {
        let secondaryOpps = secondaryopportunities[0] || secondaryopportunities;
        let secondarySelectedProduct = secondaryOpps.item_groups;
        var prevProd = JSON.parse(
          sessionStorage.getItem("secondary_selected_membership"),
        );
        if (secondarySelectedProduct !== null && prevProd === null) {
          TagManager.dataLayer(
            Helper.gtmEcommerceCart(
              "add_to_cart_two",
              "supp",
              getGtmProduct(secondarySelectedProduct, 1),
            ),
          );
          TagManager.dataLayer(
            Helper.gtmGeneralCheckoutStep(
              "checkoutstep_two",
              getPath(step),
              step,
            ),
          );
        }
        sessionStorage.setItem(
          "secondary_selected_membership",
          JSON.stringify(secondarySelectedProduct),
        );
      }

      getLocalStorageDatas();
      goNextStep();
    } else if (identifier === 2) {
      let secondaryOpps = secondaryopportunities[0] || secondaryopportunities;
      // let secondarySelectedProduct = secondaryOpps.item_groups.filter(x => x.isSelected === true);
      let secondarySelectedProduct = secondaryOpps.item_groups[0];
      sessionStorage.setItem(
        "secondary_selected_membership",
        JSON.stringify(secondarySelectedProduct),
      );
      getLocalStorageDatas();
      goNextStep();
    }
  }

  // Footer Button && Progressbar function
  function goPreviousStep() {
    // Check if region is QBR enabled and skip step if not.
    // QBR Step [3]
    if (step === 8 && opportunities.length > 0) {
      setStep(1);
    }
    if (step === 4 && Helper.isQbr(locationDatas) === false) {
      setStep(2);
    } else if (step === 8 && isSecondaryMember) {
      setStep(1);
    } else if (step === 8 && !isSecondaryMember) {
      setStep(1);
    } else if (step === 6 && isSecondaryMember) {
      setStep(2);
    } else {
      setStep(step - 1);
    }
  }

  async function confirmOrder() {
    setReviewLoading(true);
    let payloadObj = {};
    let payload = [];
    let child_of = "";

    for (let [index, member] of localStorageDatas.members.entries()) {
      let businessCategoryObj;
      if (Object.keys(member.selected_product).length !== 0) {
        //businessCategoryObj = localStorageDatas.business_categories[member.selected_product[0].business_category_id];
        businessCategoryObj = localStorageDatas.business_categories;
      }
      payloadObj = {
        subsidiary: businessCategoryObj.subsidiary,
        location: businessCategoryObj.location_id,
        department: businessCategoryObj.department_id,
        salutation: member.title,
        memberid: member.memberid ? member.memberid : "",
        firstname: member.first_name,
        lastname: member.last_name,
        email: member.email,
        phone1_type: null,
        phone1: member.phone_number,
        leah_phone: "",
        home_addr1: member.address_line_1,
        home_addr2: "",
        home_addr3: "",
        home_zip: member.postcode,
        home_city: member.city,
        home_country: member.country,
        home_state: member.state,
        referrer_name: "",
        hotel_last_stay: "",
        source: Helper.hotelDetected() ? "Hotel" : "Website",
        //"partner_ref_number" : partnerRefNumber,
        preferred_language: member.preferred_language
          ? member.preferred_language
          : "en",
      };
      if (member.type_of_member == "supp") {
        payloadObj["child_of"] = child_of;
      }

      if (member.memberid) {
        payloadObj["memberid"] = member.memberid;
      }
      payload.push(payloadObj);

      //get the primary memberId from the api to add on to the supp
      const PrimarymemberId = await memberApi(
        index,
        payloadObj,
        payload,
        member,
      );
      child_of = PrimarymemberId;
    }
    setReviewLoading(false);
    goNextStep();
  }

  async function memberApi(payloadIndex, memberPayload, payload, member) {
    let memberid = "";
    if (memberPayload.memberid) {
      if (memberPayload["subsidiary"]) {
        memberPayload["subsidiary"] = null;
      }
      await ApiService.memberUpdate(memberPayload)
        .then((res) => res.json())
        .then(
          (result) => {
            if (member.type_of_member == "primary_owner") {
              memberid = result.memberid;

              //lookup subsidiary
              let subResult = subsidiaryLookup(result.subsidiary);
              if (!subResult.found) {
                //not matching subsidiary so send error message
                setMemberCreationError(
                  `Our records show that you are registered in ${subResult.country}. Would you like to switch to <a href="/${subResult.code}/registration/?redirect=F" style="display: inline;text-decoration: underline;">${subResult.country}</a>? Otherwise, please contact <a target="_blank" href='https://accorplushelp.zendesk.com/hc/en-au' style="display: inline;text-decoration: underline;"> Member Services</a> to complete your transaction.`,
                );
                setReviewLoading(false);
                throw "ERROR";
                //return;
              }
            }
            if (result.errorMessage) {
              console.error("ERROR", result.errorMessage);
              setMemberCreationError(result.errorMessage);
            }
          },
          (error) => {
            console.error("error", error);
          },
        );
    } else {
      await ApiService.memberCreate(memberPayload)
        .then((res) => res.json())
        .then(
          (result) => {
            localStorageDatas.members[payloadIndex]["memberid"] =
              result.memberid;
            if (member.type_of_member == "primary_owner") {
              memberid = result.memberid;

              //lookup subsidiary
              let subResult = subsidiaryLookup(result.subsidiary);
              if (!subResult.found) {
                //not matching subsidiary so send error message
                setMemberCreationError(
                  `Our records show that you are registered in ${subResult.country}. Would you like to switch to <a href="/${subResult.code}/registration/?redirect=F" style="display: inline;text-decoration: underline;">${subResult.country}</a>? Otherwise, please contact <a target="_blank" href='https://accorplushelp.zendesk.com/hc/en-au' style="display: inline;text-decoration: underline;"> Member Services</a> to complete your transaction.`,
                );
                setReviewLoading(false);
                throw "ERROR";
                //return;
              }
            }
            if (result.errorMessage) {
              console.error("ERROR", result.errorMessage);
              setMemberCreationError(result.errorMessage);
            }
          },
          (error) => {
            console.error("error", error);
          },
        );
    }
    return memberid;
  }

  function subsidiaryLookup(subsidiary) {
    if (locationDatas.subsidiary == subsidiary) {
      let country = Helper.lookupSubsidiaryCountry(subsidiary);
      return {
        subsidiary: subsidiary,
        found: true,
        country: country.label,
        code: country.code,
      };
    }

    let country = Helper.lookupSubsidiaryCountry(subsidiary);
    return {
      subsidiary: subsidiary,
      found: false,
      country: country.label,
      code: country.code,
    };
  }

  function goNextStep() {
    if (step === 1) {
      setStep(8);
    }
    // else if(step === 2 && Helper.isQbr(locationDatas) === false) {
    //   setStep(6);
    // }
    else if (step === 4 && !isSecondaryMember) {
      setStep(8);
    } else if (step === 5 && isSecondaryMember) {
      setStep(6);
    } else {
      setStep(step + 1);
    }
  }

  // Button Product - Membership Selection
  function selectMembership(e) {
    let updatedProducts = opportunities[0].item_groups.map((item) => {
      if (item.item_group_id === e.item_group_id) {
        return {
          ...item,
          isSelected: true,
        };
      } else {
        return {
          ...item,
          isSelected: false,
        };
      }
    });
    setProducts(updatedProducts);
    let updatedOpp = opportunities;
    updatedOpp[0].item_groups = updatedProducts;
    setOpportunities(updatedOpp);
  }

  function secondaryGoogleAPIAddress() {
    autoCompleteRef2.current = new window.google.maps.places.Autocomplete(
      secondaryInputRef.current,
      googleOptions,
    );

    autoCompleteRef2.current.addListener("place_changed", async function () {
      const place = await autoCompleteRef2.current.getPlace();
      let secondaryAddressData = {};
      place.address_components.map((component, i) => {
        const componentType = component.types[0];
        switch (componentType) {
          case "street_number": {
            secondaryAddressData.address_line_1 = component.long_name;
            break;
          }

          case "route": {
            secondaryAddressData.address_line_1 += " " + component.short_name;
            break;
          }

          case "postal_code": {
            secondaryAddressData.postcode = component.long_name;
            break;
          }

          case "locality":
            secondaryAddressData.city = component.long_name;
            break;

          case "administrative_area_level_1": {
            secondaryAddressData.state = component.short_name;
            break;
          }

          case "country":
            secondaryAddressData.country = component.long_name;
            break;
        }
      });
      let storedData = primarySecondaryAddressInputFields.map(
        (primarySecondaryAddressInputFields) => {
          if (primarySecondaryAddressInputFields.name === "address_line_1") {
            return {
              ...primarySecondaryAddressInputFields,
              value: secondaryAddressData.address_line_1,
            };
          }
          if (primarySecondaryAddressInputFields.name === "address_line_2") {
            return {
              ...primarySecondaryAddressInputFields,
              value: secondaryAddressData.address_line_2,
            };
          }

          if (primarySecondaryAddressInputFields.name === "city") {
            return {
              ...primarySecondaryAddressInputFields,
              value: secondaryAddressData.city,
            };
          }

          if (primarySecondaryAddressInputFields.name === "country") {
            return {
              ...primarySecondaryAddressInputFields,
              value: secondaryAddressData.country,
            };
          }

          if (primarySecondaryAddressInputFields.name === "postcode") {
            return {
              ...primarySecondaryAddressInputFields,
              value: secondaryAddressData.postcode,
            };
          }

          if (primarySecondaryAddressInputFields.name === "state") {
            return {
              ...primarySecondaryAddressInputFields,
              value: secondaryAddressData.state,
            };
          } else {
            return {
              ...primarySecondaryAddressInputFields,
            };
          }
        },
      );
      setSecondaryPrimaryAddressInputFields(storedData);
      setSecondaryFindMyaddessInGoogle(!secondaryFindMyaddessInGoogle);
    });
  }

  function selectSecondaryMembership(e) {
    let secondaryOpps = secondaryopportunities[0] || secondaryopportunities;
    let updatedProducts = secondaryOpps.item_groups.map((item) => {
      if (item.isSelected === true) {
        return {
          ...item,
          isSelected: !item.isSelected,
        };
      }
      if (item.item_group_id === e.item_group_id) {
        return {
          ...item,
          isSelected: true,
        };
      } else {
        return {
          ...item,
          isSelected: false,
        };
      }
    });
    setIsSecondaryMember(true);
    setSecondaryMemberProducts(updatedProducts);
    let updatedOpp = secondaryOpps;
    updatedOpp.item_groups = updatedProducts;
    setSecondaryOpportunities(updatedOpp);
    //getLocalStorageDatas();
  }

  function getStorageValue(key) {
    var renewalCacheData = localStorage.getItem(key);
    var initial = JSON.parse(renewalCacheData);
    return initial;
  }

  function getUserData(id, date) {
    ApiService.getExpressRenewalData(id, date)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.subsidiary) {
            setSubsidiary(result.subsidiary);
            //let locationParam = Helper.locationSelect();
            let country = Helper.lookupSubsidiaryCountry(result.subsidiary);
            if (country) {
              let locationParams = {
                country: country.code,
              };
              runLocationData(locationParams);
            }
          }
          setUserData(result);
          setUserDataLoading(false);

          //setLocalStorageDatas(result);

          // if empty go to webapp/
          if (Object.keys(result).length === 0) {
            //window.location = baseUrl;
          } else {
            //getLocalStorageDatas(result);
            setUserNsData(result);

            if (result && result.opportunities.length > 0) {
              //this has opportunities
              // personalDetailsSubmit(result);

              setRenewalData(result);

              let oppSetup = setOpps(result);
              setOpportunities(oppSetup);

              let secondaryOppsSetup = {};
              result.supp_members.map((supp) => {
                if (supp.opportunities.length > 0) {
                  setIsSecondaryMember(true);
                  secondaryDetailsSubmit(supp);
                } else {
                  setIsSecondaryMember(false);
                }
                secondaryOppsSetup = setOpps(supp, true);
                setSecondaryOpportunities(secondaryOppsSetup);
              });

              //if secondary have no opportunities, get the general products
              if (result.supp_members.length <= 0) {
                setIsSecondaryMember(false);
                getDefaultProducts();
              }
            } else {
              //no opportunities
            }
            setIsProductLoaded(true);
            setIsLoaded(true);
          }
        },
        (error) => {
          console.error("error", error);
        },
      );
  }

  function setOpps(oppResult, isSupp) {
    let oppArr = [];

    for (let opp = 0; opp < oppResult.opportunities.length; opp++) {
      let opportunity = oppResult.opportunities[opp];
      for (let ig = 0; ig < opportunity.item_groups.length; ig++) {
        let item_group = opportunity.item_groups[ig];
        if (
          item_group.alternate_options &&
          item_group.alternate_options.alternate_items.length > 0
        ) {
          let alternate_options = item_group.alternate_options;
          for (
            let alt_items = 0;
            alt_items < alternate_options.alternate_items.length;
            alt_items++
          ) {
            let alternate_item = alternate_options.alternate_items[alt_items];
            alternate_item["tax_amt"] = alternate_item.tax_amount;
            opportunity.item_groups.push(alternate_item);
          }
        }
      }
      oppArr.push(opportunity);
    }

    //if secondary have no opportunities, get the general products
    if (isSupp && oppResult.opportunities.length <= 0) {
      getDefaultProducts();
    }

    return oppArr;
  }

  const getDefaultProducts = async () => {
    let ldSubsidiary, ldBc, ldData;
    ldData = JSON.parse(sessionStorage.getItem("location_data"));
    ldSubsidiary = subsidiary || locationDatas.subsidiary || ldData.subsidiary;
    ldBc = locationDatas.defaultPriceLevel || ldData.defaultPriceLevel;
    await ApiService.getProducts(ldBc, ldSubsidiary, null)
      .then((response) => response.json())
      .then((result) => {
        setBusinessCategories(result.business_categories);
        if (result.errorMessage) {
          setError({
            message: "Secondary Memberships : " + result.errorMessage,
          });
          return;
        }

        let defaultProducts = result;

        //filter to get non_standalone = true
        let filteredSecondaryProducts = defaultProducts.item_groups.filter(
          (item_group) => item_group.non_standalone === true,
        );
        defaultProducts["item_groups"] = filteredSecondaryProducts;
        setSecondaryOpportunities(defaultProducts);
      });
  };

  // GET THE USERS DATA.
  const getLocalStorageDatas = () => {
    const productData = window.sessionStorage.getItem("selected_membership");
    if (productData !== null)
      var storageLocalProductData = JSON.parse(productData);

    const secondaryProductData = window.sessionStorage.getItem(
      "secondary_selected_membership",
    );
    if (secondaryProductData !== null)
      var secondaryStorageLocalProductData = JSON.parse(secondaryProductData);

    const secondaryPersonalData = window.sessionStorage.getItem(
      "secondary_personal_details",
    );
    if (secondaryPersonalData !== null)
      var secondaryStorageLocalPersonalData = JSON.parse(secondaryPersonalData);

    // const secondaryPersonalData = window.sessionStorage.getItem('secondary_personal_details');
    // if ( secondaryPersonalData !== null ) {
    //   var secondaryStorageLocalPersonalData = JSON.parse(secondaryPersonalData);
    //   let secondaryStoredData = secondaryInputFields.map((secondaryInputFields) => {
    //     if(secondaryInputFields.name === 'email') {
    //       return {
    //         ...secondaryInputFields,
    //         value: secondaryStorageLocalPersonalData.email
    //       }
    //     }
    //     if(secondaryInputFields.name === 'confirm_email') {
    //       return {
    //         ...secondaryInputFields,
    //         value: secondaryStorageLocalPersonalData.confirm_email
    //       }
    //     }
    //     if(secondaryInputFields.name === 'first_name') {
    //       return {
    //         ...secondaryInputFields,
    //         value: secondaryStorageLocalPersonalData.first_name
    //       }
    //     }
    //     if(secondaryInputFields.name === 'last_name') {
    //       return {
    //         ...secondaryInputFields,
    //         value: secondaryStorageLocalPersonalData.last_name
    //       }
    //     }
    //     if(secondaryInputFields.name === 'phone_number') {
    //       return {
    //         ...secondaryInputFields,
    //         value: secondaryStorageLocalPersonalData.phone_number
    //       }
    //     }
    //     if(secondaryInputFields.name === 'title') {
    //       return {
    //         ...secondaryInputFields,
    //         value: secondaryStorageLocalPersonalData.title
    //       }
    //     }
    //     if(secondaryInputFields.name === 'preferred_language') {
    //       return {
    //         ...secondaryInputFields,
    //         value: secondaryStorageLocalPersonalData.preferred_language
    //       }
    //     }
    //     if(secondaryInputFields.name === 'tax_number') {
    //       return {
    //         ...secondaryInputFields,
    //         value: secondaryStorageLocalPersonalData.tax_number
    //       }
    //     }
    //   })
    //   setSecondaryInputFields(secondaryStoredData);
    // }

    // const secondaryAddressData = window.sessionStorage.getItem('secondary_address_details');
    // if ( secondaryAddressData !== null ) {
    //   var secondaryStorageLocalAddressData = JSON.parse(secondaryAddressData);
    //   if(primarySecondaryAddressInputFields !== null) {
    //     let secondaryAddressStorage = primarySecondaryAddressInputFields.map((primarySecondaryAddressInputFields) => {
    //       if(primarySecondaryAddressInputFields.name === 'address_line_1') {
    //         return {
    //           ...primarySecondaryAddressInputFields,
    //           value: secondaryStorageLocalAddressData.address_line_1
    //         }
    //       }
    //       if(primarySecondaryAddressInputFields.name === 'address_line_2') {
    //         return {
    //           ...primarySecondaryAddressInputFields,
    //           value: secondaryStorageLocalAddressData.address_line_2
    //         }
    //       }
    //       if(primarySecondaryAddressInputFields.name === 'city') {
    //         return {
    //           ...primarySecondaryAddressInputFields,
    //           value: secondaryStorageLocalAddressData.city
    //         }
    //       }
    //       if(primarySecondaryAddressInputFields.name === 'state') {
    //         return {
    //           ...primarySecondaryAddressInputFields,
    //           value: secondaryStorageLocalAddressData.state
    //         }
    //       }
    //       if(primarySecondaryAddressInputFields.name === 'postcode') {
    //         return {
    //           ...primarySecondaryAddressInputFields,
    //           value: secondaryStorageLocalAddressData.postcode
    //         }
    //       }
    //       if(primarySecondaryAddressInputFields.name === 'country') {
    //         return {
    //           ...primarySecondaryAddressInputFields,
    //           value: secondaryStorageLocalAddressData.country
    //         }
    //       }
    //     })
    //     setSecondaryPrimaryAddressInputFields(secondaryAddressStorage)

    //   }

    //   if(primarySecondaryBillingAddressInputFields !== null && !secondaryCheckboxAddress) {
    //     let secondaryBillingAddressStorage = primarySecondaryBillingAddressInputFields.map((primarySecondaryBillingAddressInputFields) => {
    //       if(primarySecondaryBillingAddressInputFields.name === 'billing_address_line_1') {
    //         return {
    //           ...primarySecondaryBillingAddressInputFields,
    //           value: secondaryStorageLocalAddressData.billing_address_line_1
    //         }
    //       }
    //       if(primarySecondaryBillingAddressInputFields.name === 'billing_address_line_2') {
    //         return {
    //           ...primarySecondaryBillingAddressInputFields,
    //           value: secondaryStorageLocalAddressData.billing_address_line_2
    //         }
    //       }
    //       if(primarySecondaryBillingAddressInputFields.name === 'billing_city') {
    //         return {
    //           ...primarySecondaryBillingAddressInputFields,
    //           value: secondaryStorageLocalAddressData.billing_city
    //         }
    //       }
    //       if(primarySecondaryBillingAddressInputFields.name === 'billing_state') {
    //         return {
    //           ...primarySecondaryBillingAddressInputFields,
    //           value: secondaryStorageLocalAddressData.billing_state
    //         }
    //       }
    //       if(primarySecondaryBillingAddressInputFields.name === 'billing_postcode') {
    //         return {
    //           ...primarySecondaryBillingAddressInputFields,
    //           value: secondaryStorageLocalAddressData.billing_postcode
    //         }
    //       }
    //       if(primarySecondaryBillingAddressInputFields.name === 'billing_country') {
    //         return {
    //           ...primarySecondaryBillingAddressInputFields,
    //           value: secondaryStorageLocalAddressData.billing_country
    //         }
    //       }
    //     })
    //     setSecondaryPrimaryBilliingAddressInputFields(secondaryBillingAddressStorage)
    //   }
    // }

    // const secondaryProductData = window.sessionStorage.getItem('secondary_selected_membership');
    // if ( productData !== null ) var secondaryStorageLocalProductData = JSON.parse(secondaryProductData);

    // const secondaryPersonalData = window.sessionStorage.getItem('secondary_personal_details');
    // if ( personalData !== null ) var secondaryStorageLocalPersonalData = JSON.parse(secondaryPersonalData);
    // setSecondaryPersonalDetailsInput(JSON.parse(personalData));

    // const secondaryAddressData = window.sessionStorage.getItem('secondary_address_details');
    // if ( addressData !== null ) var secondaryStorageLocalAddressData = JSON.parse(secondaryAddressData);

    let primary_input_data = {
      type_of_member: "primary_owner",
      memberid: renewalData.memberid,
      leah_card_number: renewalData.leah_card_number,
      pmid: renewalData.pmid,
    };

    const localstorageData = {
      business_categories: { ...userNsData },
      members: [
        {
          selected_product: { ...storageLocalProductData },
          // ...storageLocalPersonalData,
          // ...storageLocalAddressData,
          ...primary_input_data,
          type_of_member: "primary_owner",
          isShown: true,
          //"memberid": memberId
        },
      ],
      hotelRIDOnlineKiosk: "",
      apHotelEmployeeName: "",
      hotelEmployee: "",
      apHotelEmployeeId: "",
      source: "Website",
      step,
    };

    // if(secondaryopportunities.length > 0) {
    if (secondaryStorageLocalProductData && isSecondaryMember) {
      localstorageData.members.push({
        selected_product: { ...secondaryStorageLocalProductData },
        ...secondaryStorageLocalPersonalData,
        type_of_member: "supp",
        card: false,
        isShown: true,
        //"memberid": memberId
      });
    }
    setLocalStorageDatas(localstorageData);
  };

  // [Secondary] Address - Input state changes
  function handleSecondaryAddressInput(e) {
    var inputName = e.target.name;
    var inputValue = e.target.value;
    let storedData = primarySecondaryAddressInputFields.map(
      (primarySecondaryAddressInputFields) => {
        if (primarySecondaryAddressInputFields.name === inputName) {
          return {
            ...primarySecondaryAddressInputFields,
            value: inputValue,
          };
        } else {
          return {
            ...primarySecondaryAddressInputFields,
          };
        }
      },
    );
    setSecondaryPrimaryAddressInputFields(storedData);
  }

  // [Secondary] Address - Input state changes
  function handleSecondaryBillingAddressInput(e) {
    var inputName = e.target.name;
    var inputValue = e.target.value;
    let storedData = primarySecondaryBillingAddressInputFields.map(
      (primarySecondaryBillingAddressInputFields) => {
        if (primarySecondaryBillingAddressInputFields.name === inputName) {
          return {
            ...primarySecondaryBillingAddressInputFields,
            value: inputValue,
          };
        } else {
          return {
            ...primarySecondaryBillingAddressInputFields,
          };
        }
      },
    );
    setSecondaryPrimaryBilliingAddressInputFields(storedData);
  }

  // [Address] Address Step
  function secondaryAddressFind() {
    setSecondaryFindMyaddessInGoogle(!secondaryFindMyaddessInGoogle);
  }

  // [Secondary] checkbox
  function handleSecondaryCheckboxAddress() {
    setSecondaryCheckboxAddress(!secondaryCheckboxAddress);
  }

  // [Step] - Review Step
  function handleCardCheckBox(params, index) {
    let updatedProducts = localStorageDatas.members.map((item) => {
      if (item.type_of_member === params.type_of_member) {
        return {
          ...item,
          card: !item.card,
        };
      } else {
        return {
          ...item,
        };
      }
    });
    setLocalStorageDatas((prevState) => ({
      ...prevState,
      ["members"]: updatedProducts,
    }));
  }

  function handleShowList(params, index) {
    let updatedProducts = localStorageDatas.members.map((item) => {
      if (item.type_of_member === params.type_of_member) {
        return {
          ...item,
          isShown: !item.isShown,
        };
      } else {
        return {
          ...item,
        };
      }
    });
    setLocalStorageDatas((prevState) => ({
      ...prevState,
      ["members"]: updatedProducts,
    }));
  }

  // [Primary] - Input state changes
  function inputChange(e) {
    var inputName = e.target.name;
    var inputValue = e.target.value;
    let storedData = isCountryIndiaPrimary.map((secondaryInputFields) => {
      if (secondaryInputFields.name === inputName) {
        return {
          ...secondaryInputFields,
          value: inputValue,
        };
      } else {
        return {
          ...secondaryInputFields,
        };
      }
    });
    setSecondaryInputFields(storedData);
  }

  function inputPhoneChange(inputVal, name, country) {
    var dialCode = name.dialCode; // get dialcode length
    var localNumber = "0" + inputVal.slice(dialCode.length);
    var countryCodeValLeading0 = parseInt(localNumber, 10);
    var leahNum = dialCode + countryCodeValLeading0; // concat code + val without leading 0
    var phoneNum = "+" + inputVal;
    var validatedPhoneNum = phone(phoneNum);

    const phoneObj = {
      ...validatedPhoneNum,
      localNumber, // ex. 045 XXX XXXX
      countryCodeValLeading0, // ex. 45 XXX XXXX'
      leahNum, // ex. 61 45 XXX XXXX
      dialCode, // ex. 61
    };

    let storedData = secondaryInputFields.map((secondaryInputFields) => {
      if (secondaryInputFields.name === "phone_number") {
        if (inputVal.length < 9) {
          // changed it to 9 for the trunk
          return {
            ...secondaryInputFields,
            value: phoneObj,
            valid: false,
            isError: true,
            message:
              "This field must contains a valid phone number and mush not be less than 10 digits.",
          };
        } else {
          return {
            ...secondaryInputFields,
            value: phoneObj,
            valid: true,
            isError: false,
            message: "",
          };
        }
      } else {
        return {
          ...secondaryInputFields,
        };
      }
    });
    setSecondaryInputFields(storedData);
  }

  // checkmemberexist
  const checkMemberExist = (params) => {
    let valid;
    let error;
    let message;
    setMemberStatus(false);

    if (secondaryInputFields) {
      ApiService.memberStatus(params, locationDatas.emailCheck)
        .then((res) => res.json())
        .then(
          (result) => {
            if (result.errorMessage) {
              valid = false;
              error = true;
              message =
                "Email does not seem to be recognized. Please try again.";
            } else if (
              result &&
              result.status_text &&
              (result.status_text === "MEMBER-Current Member" ||
                result.status_text === "MEMBER-In Progress")
            ) {
              valid = false;
              error = true;
              message =
                "The email is in use by an existing member. Please login to continue or contact Member Services for further assistance.";
            } else {
              if (
                result.status_text === "MEMBER-Lapsed Member" ||
                result.status_text === "MEMBER-Pending Member" ||
                !result.memberid
              ) {
              }
              valid = true;
              error = false;
              message = "";
            }
            if (secondaryInputFields) {
              let memberCheck = secondaryInputFields.map((item) => {
                if (item.name === "email") {
                  return {
                    ...item,
                    checking: false,
                    valid: valid,
                    message: message,
                    isError: error,
                  };
                } else {
                  return {
                    ...item,
                  };
                }
              });
              setSecondaryInputFields(memberCheck);
            }
            setMemberId(result.memberid);
            setMemberStatus(true);
          },
          (error) => {
            console.error("error", error);
            setMemberStatus(false);
          },
        );
    }
  };

  //Payment Process Transaction ID
  function processPayment(transactionId) {
    if (
      window.dataLayer.filter((a) => a.event === "begin_checkout").length < 1
    ) {
      TagManager.dataLayer(
        Helper.gtmBeginCheckout(
          locationDatas.currency,
          window.location.pathname,
          productsForGtm(),
        ),
      );
      commissionJunction = commissionJunctionRules(locationDatas);
    }
    const payment_data = {
      ...localStorageDatas,
      transactionId: transactionId,
    };
    setLocalStorageDatas(payment_data);
    goNextStep();
  }

  function declinedSecondaryMembership() {
    setIsSecondaryMember(false);
    var prevProd = JSON.parse(
      sessionStorage.getItem("secondary_selected_membership"),
    );
    if (prevProd !== null) {
      TagManager.dataLayer(
        Helper.gtmEcommerceCart(
          "remove_from_cart_two",
          "supp",
          getGtmProduct(prevProd, 1),
        ),
      );
      window.sessionStorage.removeItem("secondary_selected_membership");
    }
    // localStorageDatas.members.splice(localStorageDatas.members.findIndex(member => member.type_of_member === "supp"),1);
    // goNextStep(false)
    setStep(8);
  }

  // Inputs Fields Validation Check
  // For Both Primary and Secondary Members
  function onFieldBlur(e) {
    const name = e.target.name;
    const value = e.target.value;
    let message;
    let error;
    let valid;
    let checking;

    if (name === "email") {
      if (value) {
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
          message = "Please enter a valid email address.";
          error = true;
          valid = false;
        } else {
          valid = false;
          checking = true;
          error = false;
          checkMemberExist({ email: value });
        }
      }
    }
    if (name === "confirm_email") {
      if (value) {
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
          message = "Please enter a valid email address.";
          error = true;
        } else if (
          secondaryInputFields[0].value &&
          secondaryInputFields[0].value !== value
        ) {
          error = true;
          message = "Email Address does not match!";
        } else {
          message = "";
          error = false;
          valid = true;
        }
      }
    }

    if (name === "first_name" || name === "last_name") {
      if (!value) {
        message = "This field is mandatory and must be filled out.";
        error = true;
      } else {
        var validation = Helper.characterLimit(name, value);
        if (!validation) {
          message = "This field must not exceed 25 characters.";
          error = true;
        } else {
          message = "";
          error = false;
          valid = true;
        }
      }
    }

    // if( name === 'phone_number'){
    //   var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    //   if((value.match(phoneno))){
    //     message = '';
    //     error   = false;
    //     valid   = true;
    //   } else {
    //     message = 'This field must contains a valid phone number.';
    //     error   = true;
    //   }
    // }
    if (name === "title") {
      message = "";
      error = false;
      valid = true;
    }

    let validationSecondaryCheckedFields = secondaryInputFields.map((item) => {
      if (item.name === name) {
        return {
          ...item,
          isError: error,
          message: message,
          checking: checking,
          valid: valid,
        };
      } else {
        return {
          ...item,
        };
      }
    });

    setSecondaryInputFields(validationSecondaryCheckedFields);
  }

  // Header modal
  function handleShowModal(e) {
    e.preventDefault();
    setShowModal(true);
  }

  // Header modal
  function onCloseModal() {
    setShowModal(false);
  }

  // [Secondary] submit
  function onSubmitSecondaryAddressDetails(e) {
    const message = "This field is mandatory and must be filled out.";
    let addressValidate = primarySecondaryAddressInputFields.map((item) => {
      if (item.name === "address_line_1" && !item.value) {
        return {
          ...item,
          isError: true,
          message: message,
        };
      } else if (item.name === "city" && !item.value) {
        return {
          ...item,
          isError: true,
          message: message,
        };
      } else if (item.name === "country" && !item.value) {
        return {
          ...item,
          isError: true,
          message: message,
        };
      } else {
        return {
          ...item,
          isError: false,
          message: "",
        };
      }
    });
    let addressArr = [];
    let billingArr = [];
    let storedData = primarySecondaryAddressInputFields.map(
      (primarySecondaryAddressInputFields) => {
        if (primarySecondaryAddressInputFields.name) {
          return {
            name: primarySecondaryAddressInputFields.name,
            value: primarySecondaryAddressInputFields.value,
          };
        }
      },
    );
    addressArr.push(storedData);
    var input_data = {};
    for (var i = 0; i < addressArr[0].length; i++) {
      input_data[addressArr[0][i].name] = addressArr[0][i].value;
    }
    let storedBillingData = primarySecondaryBillingAddressInputFields.map(
      (primarySecondaryBillingAddressInputFields) => {
        if (primarySecondaryBillingAddressInputFields.name) {
          return {
            name: primarySecondaryBillingAddressInputFields.name,
            value: primarySecondaryBillingAddressInputFields.value,
          };
        }
      },
    );
    billingArr.push(storedBillingData);
    var input_billing_data = {};
    for (var i = 0; i < billingArr[0].length; i++) {
      input_billing_data[billingArr[0][i].name] = billingArr[0][i].value;
    }
    let addressDetails;
    if (secondaryCheckboxAddress) {
      var billing = {
        billing_address_line_1: input_data.address_line_1,
        billing_city: input_data.city,
        billing_country: input_data.country,
        billing_postcode: input_data.postcode,
        billing_state: input_data.state,
      };
      addressDetails = {
        ...input_data,
        ...billing,
      };
    } else {
      addressDetails = {
        ...input_data,
        ...input_billing_data,
      };
    }
    if (
      addressDetails === null ||
      addressDetails.address_line_1 === "" ||
      addressDetails.city === "" ||
      addressDetails.country === ""
    ) {
      secondaryFindMyaddessInGoogle
        ? setSecondaryGoogleAddressEmpty(true)
        : setSecondaryPrimaryAddressInputFields(addressValidate);
    } else {
      sessionStorage.setItem(
        "secondary_address_details",
        JSON.stringify(addressDetails),
      );
      goNextStep();
    }
  }

  // [Secondary] Main Address
  const secondaryAddressInputDetails = [
    {
      name: "address_line_1",
      type: "text",
      maxLength: 32,
      value: "",
      placeholder: "Address Line 1*",
      icon: Home,
      required: true,
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "address_line_2",
      type: "text",
      maxLength: 32,
      value: "",
      placeholder: "Address Line 2",
      icon: Home,
      required: false,
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "city",
      type: "text",
      value: "",
      placeholder: "City*",
      icon: City,
      required: true,
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "state",
      type: "text",
      value: "",
      placeholder: "State*",
      icon: State,
      required: true,
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "postcode",
      type: "text",
      value: "",
      placeholder: "Postcode",
      icon: Postcode,
      required: false,
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "country",
      type: "select",
      options: countryList,
      value: "",
      placeholder: "Country*",
      icon: Country,
      required: true,
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
  ];

  const secondaryBillingAddress = [
    {
      name: "billing_address_line_1",
      type: "text",
      maxLength: 32,
      placeholder: "Billing Address Line 1*",
      icon: Home,
      value: "",
      required: true,
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "billing_address_line_2",
      type: "text",
      maxLength: 32,
      placeholder: "Billing Address Line 2",
      icon: Home,
      value: "",
      required: true,
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "billing_city",
      type: "text",
      placeholder: "City*",
      icon: City,
      value: "",
      required: true,
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "billing_state",
      type: "text",
      placeholder: "State*",
      icon: State,
      value: "",
      required: true,
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "billing_postcode",
      type: "text",
      placeholder: "Postcode",
      icon: Postcode,
      value: "",
      required: true,
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "billing_country",
      type: "text",
      placeholder: "Country*",
      icon: Country,
      value: "",
      required: true,
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
  ];

  var isCountryIndiaPrimary;

  if (locationDatas.country === "in" || locationDatas.country === "IN") {
    isCountryIndiaPrimary = secondaryInputFields;
  } else {
    isCountryIndiaPrimary = secondaryInputFields.filter(
      (x) => x.name !== "tax_number",
    );
  }

  // load renewal user data [Primary]
  const personalRenewalData = () => {
    let storedData = isCountryIndiaPrimary.map((secondaryInputFields) => {
      if (secondaryInputFields.name === "email") {
        return {
          ...secondaryInputFields,
          value: renewalData.email,
        };
      }
      if (secondaryInputFields.name === "title") {
        return {
          ...secondaryInputFields,
          value: renewalData.salutation,
        };
      }
      if (secondaryInputFields.name === "first_name") {
        return {
          ...secondaryInputFields,
          value: renewalData.firstname,
        };
      }
      if (secondaryInputFields.name === "last_name") {
        return {
          ...secondaryInputFields,
          value: renewalData.lastname,
        };
      }
      if (secondaryInputFields.name === "phone_number") {
        return {
          ...secondaryInputFields,
          value: renewalData.phone1,
        };
      } else {
        return {
          ...secondaryInputFields,
        };
      }
    });
    setSecondaryInputFields(storedData);
  };

  // [Secondary]
  const [
    primarySecondaryAddressInputFields,
    setSecondaryPrimaryAddressInputFields,
  ] = useState(secondaryAddressInputDetails);
  const [
    primarySecondaryBillingAddressInputFields,
    setSecondaryPrimaryBilliingAddressInputFields,
  ] = useState(secondaryBillingAddress);

  if (error) {
    // return <div>Error: {error.message}</div>;
    return (
      <ErrorComponent
        errorMessage={`Error: ${error.message}. Please <a href='contact' style='display: contents;'>contact Member Services</a> for more information.`}
      />
    );
  } else if (userDataLoading) {
    return <LoadingScreen />;
  } else if (opportunities.length <= 0) {
    return (
      <div>
        <Header
          goPreviousStep={goPreviousStep}
          step={step}
          headerText={headerText}
          languages={languages}
          productError={productError}
          handleShowModal={handleShowModal}
          isUserLogged={isUserLogged}
        />

        <ErrorComponent
          errorMessage={
            "We apologise, but we could not proceed with your request. Please <a href='https://accorplushelp.zendesk.com/hc/en-au' style='display: contents;'>contact Member Services</a> for more information."
          }
        />
      </div>
    );
  } else {
    return (
      isLogged && (
        <>
          <div className="renewal">
            <div className="container mx-auto xs:px-3.5 laptop:px-4">
              <div className="register-wrapper">
                {/* <div className='progress-bar'>
                      <Progress className='progressbar' progress={progress} />
                    </div> */}

                <Header
                  goPreviousStep={goPreviousStep}
                  step={step}
                  headerText={headerText}
                  languages={languages}
                  productError={productError}
                  handleShowModal={handleShowModal}
                  isUserLogged={isUserLogged}
                />

                {/* Static Step 1 */}
                {isLoaded && isProductLoaded && opportunities.length > 0 ? (
                  <ProductStep
                    currentStep={step.toString()}
                    languages={languages}
                    locationData={locationDatas}
                    products={opportunities[0].item_groups}
                    selectMembership={selectMembership}
                    isProductLoaded={isProductLoaded}
                    error={productError}
                    locationDataCurrency={locationDataCurrency}
                    stepNo={1}
                  />
                ) : (
                  <ErrorComponent
                    errorMessage={
                      "We apologise, but we could not proceed with your request. Please <a href='https://accorplushelp.zendesk.com/hc/en-au' style='display: contents;'>contact Member Services</a> for more information."
                    }
                  />
                )}

                {isLoaded && isProductLoaded && secondaryopportunities ? ( //&& (secondaryopportunities && (secondaryopportunities.length > 0 && secondaryopportunities[0].item_groups.length > 0) || (secondaryopportunities.item_groups.length > 0)) ?
                  <SecondaryProductStep
                    currentStep={step}
                    languages={languages}
                    locationData={locationDatas}
                    products={
                      secondaryopportunities.length > 0
                        ? secondaryopportunities[0].item_groups
                        : secondaryopportunities.item_groups
                    }
                    // products={secondaryopportunities[0].item_groups}
                    selectMembership={selectSecondaryMembership}
                    isProductLoaded={isProductLoaded}
                    error={productError}
                    locationDataCurrency={locationDataCurrency}
                    goNextStep={goNextStep}
                    stepNo={2}
                  />
                ) : null}

                {/* {isSecondaryMember &&
                      <SecondaryPersonalDetailStep 
                        currentStep                    = {step}
                        languages                      = {languages}
                        locationData                   = {locationDatas}
                        goNextStep                     = {goNextStep}
                        onFieldBlur                    = {onFieldBlur}
                        secondaryInputChange           = {inputChange}
                        secondaryInputPhoneChange      = {inputPhoneChange}
                        inputSecondaryPersonalEl       = {inputSecondaryPersonalEl}
                        secondaryPersonalDetailsSubmit = {secondaryPersonalDetailsSubmit}
                        taxNumberIN                    = {true}
                        secondaryInputFields           = {isCountryIndiaPrimary}
                        stepNo                         = {6}
                      />
                    }
                    {
                      isSecondaryMember && 
                      <SecondaryAddressStep 
                        stepNo         = {7}
                        currentStep    = {step}
                        languages      = {languages}
                        locationData   = {locationDatas}
                        goNextStep     = {goNextStep}
                        options        = {googleOptions}
                        inputFields    = {primarySecondaryAddressInputFields} //state
                        billingAddress = {primarySecondaryBillingAddressInputFields} //state

                        secondaryInputRef              = {secondaryInputRef}
                        secondaryAddressFind           ={secondaryAddressFind}
                        inputSecondaryAddressEl        ={inputSecondaryAddressEl}
                        inputSecondaryAddressBillingEl = {inputSecondaryAddressBillingEl}
                        onSubmitAddressDetails         = {onSubmitSecondaryAddressDetails}
                        handleSecondaryCheckboxAddress = {handleSecondaryCheckboxAddress}
                        secondaryCheckboxAddress       = {secondaryCheckboxAddress}
                        
                        autoCompleteRef2                   ={autoCompleteRef2}
                        secondaryGoogleAddressEmpty        = {secondaryGoogleAddressEmpty}
                        handleSecondaryAddressInput        = {handleSecondaryAddressInput}
                        handleSecondaryBillingAddressInput = {handleSecondaryBillingAddressInput}
                        secondaryFindMyaddessInGoogle      ={secondaryFindMyaddessInGoogle}
                        // secondaryAddressInput={secondaryAddressInput}
                      />
                    } */}

                <ReviewStep
                  currentStep={step}
                  languages={languages}
                  locationData={locationDatas}
                  localStorageDatas={localStorageDatas}
                  goNextStep={goNextStep}
                  editReview={editReview}
                  checkBoxTerms={checkBoxTerms}
                  handleCheckBoxTerms={handleCheckBoxTerms}
                  handleCardCheckBox={handleCardCheckBox}
                  readMeTerms={readMeTerms}
                  stepNo={8}
                  isExpress={true}
                  isRenewalPage={false}
                  handleShowList={handleShowList}
                  inputPromoEl={inputPromoEl}
                  termsLink={TERMS_CONDITIONS_LINK}
                  editItemLink={SSO_LOGIN}
                  memberId={memberId}
                  // removeProduct     = {removeProduct}
                  isSecondaryMember={isSecondaryMember}
                  businessCategories={businessCategories}
                  memberCreationError={memberCreationError}
                  setIsUserLogged={isUserLogged}
                />

                <PaymentStep
                  currentStep={step}
                  languages={languages}
                  locationData={locationDatas}
                  localStorageDatas={localStorageDatas}
                  goNextStep={processPayment}
                  stepNo={9}
                  isUserLogged={false}
                  isExpress={true}
                  category="express-checkout"
                  businesscategory={queryParams.get("bc")}
                  businessCategories={businessCategories}
                />

                <ConfirmationStep
                  currentStep={step}
                  languages={languages}
                  locationData={locationDatas}
                  localStorageDatas={localStorageDatas}
                  isExpress={true}
                  goNextStep={goNextStep}
                  stepNo={10}
                />

                <ExploreStep
                  currentStep={step}
                  languages={languages}
                  localStorageDatas={localStorageDatas}
                  goNextStep={goNextStep}
                  isRenewalPage={true}
                  isExpress={true}
                  stepNo={11}
                />

                {step === 11 ? null : (
                  <StickyFooter
                    isProcessing={isProcessing}
                    goNextStep={goNextStep}
                    confirmOrder={confirmOrder}
                    currentStep={step}
                    products={products} //[Primary]
                    checkBoxTerms={checkBoxTerms} // [Step] - Review
                    reviewLoading={reviewLoading} // [Step] - Review
                    memberStatus={memberStatus} // [Step] - Personal Details
                    languages={languages}
                    storeMembershipData={storeMembershipData}
                    onMouseHover={onMouseHover}
                    onMouseLeave={onMouseLeave}
                    personalDetailsInput={personalDetailsInput}
                    secondaryProducts={secondaryProducts} // [Secondary]
                    declinedSecondaryMembership={declinedSecondaryMembership} // [Secondary]
                    secondaryPersonalDetailsSubmit={
                      secondaryPersonalDetailsSubmit
                    }
                    onSubmitSecondaryAddressDetails={
                      onSubmitSecondaryAddressDetails
                    }
                    // personalDetailsSubmit={personalDetailsSubmit}
                  />
                )}

                {/*<div className='dynamic-component tablet:pt-4'>
                      <form className='form w-full' onSubmit={onSubmit}>
                        <InputFields 
                          inputFields={personalDetailsInputFields} 
                          inputChange={(e) => setPersonalInput(prevState => ({...prevState, [e.target.name]: e.target.value}))}
                        />

                        <p className='font-montserrat font-bold text-xl text-center my-5'>Address details</p>

                        <InputFields 
                          inputFields={addressInputDetails} 
                          inputChange={(e) => setAddressInput(prevState => ({...prevState, [e.target.name]: e.target.value}))}
                        />

                        <div className="flex items-center my-5">
                          <input 
                            id="link-checkbox" 
                            type="checkbox" 
                            checked={checkboxAddress}
                            disabled={true}
                            onChange={() => setCheckboxAddress(!checkboxAddress)}
                            className="d-none w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" 
                          />
                          
                          <label htmlFor="link-checkbox" className="link-checkbox text-sm font-medium text-gray-900 dark:text-gray-300">
                            <span className='checkbox-icon mr-4'>{ ship_addr1 || ship_addr2 ? <CheckBoxBlank /> : <CheckBoxTick /> }</span>
                            My billing address is the same as my address.
                          </label>
                        </div>  

                        {
                          checkboxAddress ? null : (
                            <InputFields 
                              inputFields={billingAddressDetails} 
                              inputChange={(e) => setBillingAddress(prevState => ({...prevState, [e.target.name]: e.target.value}))}
                            />
                          )
                        }}
                        { <button type='submit'>renew</button> }
                      </form>
                      </div>*/}

                {/* <StickyFooter 
                      isProcessing={isProcessing}
                      // goNextStep={goNextStep}
                      products={null}
                      currentStep={step} 
                    /> */}
              </div>
            </div>
          </div>
          <CTA
            onCloseModal={onCloseModal}
            showModal={showModal}
            languages={languages}
          />
        </>
      )
    );
  }
}

export default ExpressCheckout;
